var _desc, _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin-open") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 20 0 20 26 0 26"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin-start"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m10.002 0c-5.5111 0-10.002 4.5378-10.002 10.111 0 4.0617 2.4223 7.8664 4.7586 10.702 2.3364 2.8352 4.6727 4.7254 4.6727 4.7254l0.57035 0.46211 0.57035-0.46211s2.3364-1.8902 4.6727-4.7254c2.3364-2.8352 4.7552-6.6399 4.7552-10.702 0-5.5732-4.4872-10.111-9.9983-10.111",
    fill: "#d8232a"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.060403 0 0 .060507 1 -.75173)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m298 178.25h-59.517c-3.323-9.592-12.442-16.5-23.151-16.5-13.51 0-24.5 10.99-24.5 24.5s10.99 24.5 24.5 24.5c10.709 0 19.828-6.908 23.151-16.5h59.517zm-74.168 8c0 4.687-3.814 8.5-8.5 8.5-4.687 0-8.5-3.813-8.5-8.5 0-4.686 3.813-8.5 8.5-8.5 4.686 0 8.5 3.813 8.5 8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.01 87.252-76.967 76.967c-3.238-1.582-6.873-2.472-10.713-2.472-10.709 0-19.828 6.908-23.151 16.5h-60.183v16h60.183c3.323 9.592 12.442 16.5 23.151 16.5 13.51 0 24.5-10.99 24.5-24.5 0-3.841-0.891-7.476-2.472-10.715l76.966-76.966zm-96.18 98.996c0-4.686 3.813-8.5 8.5-8.5s8.5 3.814 8.5 8.5c0 4.687-3.813 8.5-8.5 8.5s-8.5-3.814-8.5-8.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOpen);
export default __webpack_public_path__ + "static/media/pin-open.cfae3985933ec12c71a70397a87206a7.svg";
export { ForwardRef as ReactComponent };